import Model from "./Model";
import AssemblyParameters from "./AssemblyParameters";
import Component from "./Component";
import Dataset from "./Dataset";

export default class Session extends Model {

	constructor(props) {

		super({});

		this.setDefaultValues({
			id: null,
			hash: null,
			strategy: null,
			component: null,
			dataset: null,
			parameters: new AssemblyParameters()
		}, props);

		if (this.component) {
			this.component = new Component(this.component);
		}

		if (this.dataset) {
			this.dataset = new Dataset(this.dataset);
		}
	}
}
